export default {
  calculator: {
    buyLabelName: 'у меня',
    swapButtonAriaLabel: 'поменять валюты местами',
    sellLabelName: 'получу',
    currentRate: 'Текущий курс:',
    continueButton: 'Продолжить обмен',
    miniChart: 'Мини-график показывает колебания среднего курса за последние 7 дней',
    sellTooltip:
      'Это курс продажи — мы продаём Тебе {{currency}} по {{rate}} PLN. Чем ниже курс, тем выгоднее для Тебя. Автообновление каждые 10 секунд.',
    buyTooltip:
      'Это курс покупки — мы покупаем у Тебя {{currency}} по {{rate}} PLN. Чем выше курс, тем выгоднее для Тебя. Автообновление каждые 10 секунд.',
    saleNotAvailableInfo: 'В настоящее время продажа {{baseCurrency}} недоступна',
    minAmount: 'Минимальная сумма обмена — {{minAmount}} {{minCurrency}}.',
  },
  creditCalculator: {
    monthlyLoan: 'Ежемесячный платёж по кредиту',
    loanTerm: 'До конца кредита осталось',
    whichBank: 'В каком банке Ты оплачиваешь кредит?',
    save: 'Экономь!',
    years: 'лет',
    inYear: 'за год',
    toEnd: 'до конца кредита',
    installmentAmount: 'Сумма платежа слишком мала',
  },
  transferTypes: {
    INTERNAL:
      'Деньги поступят примерно через 30 минут после получения Твоего перевода, не позднее следующего рабочего дня.',
    TODAY: 'Деньги поступят не позднее следующего рабочего дня.',
    TODAY_OUR: 'Деньги поступят не позднее следующего рабочего дня.',
    SEPA: 'Деньги поступят в течении 1 - 2 рабочих дней.',
    SEPA_INSTANT: 'Деньги поступят примерно за 1 минуту.',
    SPOT: 'Деньги поступят в течении 2 - 3 рабочих дней.',
    ELIXIR: 'Деньги поступят не позднее следующего рабочего дня.',
    LOCAL: 'Деньги поступят не позднее следующего рабочего дня.',
  },
  profitCalculator: {
    transferNotSupported: 'Выбранный банк не поддерживает переводы этой валюты.',
    transferFree: 'Мы не взимаем комиссий за отправку обмененных средств!',
    transferFee:
      'За перевод в выбранный Тобой банк взимается банковская комиссия – {{transferFee}} PLN. Комиссия уже учтена в расчёте.',
  },
  preactSelect: {
    search: 'Поиск...',
  },
  newsletter: {
    alreadySubscribed: 'Твой e-mail уже подписан на нашу рассылку.',
    error: 'Что-то пошло не так. Попробуй позже.',
  },
  frontpageExitPopup: {
    accountExists: 'Похоже, у Тебя уже есть учётная запись. Скидка только для новых клиентов.',
    error: 'Произошла ошибка',
  },
  emailValidator: {
    requiredField: 'Необходимо отметить это поле',
    notEmptyField: 'Это поле не может быть пустым',
    minValue: 'Минимальное значение  –',
    maxValue: 'Максимальное значение –',
    incorrectEmail: 'Введи корректный адрес электронной почты',
    toShortPassword: 'Пароль слишком короткий',
  },
  currencyAlert: {
    isLower: 'будет ниже',
    isHigher: 'будет выше',
    mustBeLessThan: 'Курс должен быть числом меньше 99,9999',
    alertAlreadyExists: 'Оповещение для этого курса уже существует',
    maxAlerts: 'Ты не можешь подписаться на большее количество оповещений (макс. 10)',
    error: 'Что-то пошло не так, попробуй через минуту.',
    alertHash: 'валютное-оповещение',
    averageRateNotAvailable:
      'Сейчас невозможно установить оповещение, так как курс {{currency}} временно недоступен ({{averageRate}}).',
  },
  ratesUpdate: {
    update: 'Идёт обновление курсов...',
    success: 'Следующее обновление курса через',
    error: 'Не удалось получить данные. Повтор через',
  },
  currencyAnnotations: {
    notSupported: 'Обмен этой валюты в настоящее время недоступен',
  },
  currencies: {
    AED: 'Дирхам ОАЭ',
    ARS: 'Аргентинское песо',
    AUD: 'Австралийский доллар',
    BDT: 'Бангладешская така',
    BGN: 'Болгарский лев',
    BRL: 'Бразильский реал',
    CAD: 'Канадский доллар',
    CHF: 'Швейцарский франк',
    CLP: 'Чилийское песо',
    CNY: 'Китайский юань',
    COP: 'Колумбийское песо',
    CZK: 'Чешская крона',
    DKK: 'Датская крона',
    EGP: 'Египетский фунт',
    EUR: 'Евро',
    FJD: 'Доллар Фиджи',
    GBP: 'Фунт стерлингов',
    GHS: 'Ганский седи',
    HKD: 'Гонконгский доллар',
    HUF: 'Венгерский форинт',
    ILS: 'Израильский новый шекель',
    INR: 'Индийская рупия',
    JOD: 'Иорданский динар',
    JPY: 'Японская иена',
    KWD: 'Кувейтский динар',
    LSL: 'Лоти Лесото',
    MXN: 'Мексиканское песо',
    NOK: 'Норвежская крона',
    NPR: 'Непальская рупия',
    NZD: 'Новозеландский доллар',
    OMR: 'Оманский риал',
    PEN: 'Перуанский соль',
    PGK: 'Кина Папуа — Новой Гвинеи',
    PLN: 'Польский злотый',
    RON: 'Румынский лей',
    RUB: 'Российский рубль',
    SAR: 'Саудовский риял',
    SEK: 'Шведская крона',
    SGD: 'Сингапурский доллар',
    SZL: 'Свазилендский лилангени',
    THB: 'Тайский бат',
    TRY: 'Турецкая лира',
    USD: 'Доллар США',
    UYU: 'Уругвайское песо',
    WST: 'Самоанская тала',
    ZAR: 'Южноафриканский ранд',
  },
  currenciesDopelniacz: {
    AED: 'дирхама ОАЭ',
    ARS: 'аргентинского песо',
    AUD: 'австралийского доллара',
    BDT: 'бангладешской таки',
    BGN: 'болгарского лева',
    BRL: 'бразильского реала',
    CAD: 'канадского доллара',
    CHF: 'швейцарского франка',
    CNY: 'китайского юаня',
    CZK: 'чешской кроны',
    DKK: 'датской кроны',
    EGP: 'египетского фунта',
    EUR: 'евро',
    FJD: 'доллара Фиджи',
    GBP: 'фунта стерлингов',
    GHS: 'ганского седи',
    HKD: 'гонконгского доллара',
    INR: 'индийской рупии',
    JOD: 'иорданского динара',
    KWD: 'кувейтского динара',
    LSL: 'лоти Лесото',
    MXN: 'мексиканского песо',
    NOK: 'норвежской кроны',
    NPR: 'непальской рупии',
    NZD: 'новозеландского доллара',
    OMR: 'оманского риала',
    PEN: 'перуанского соля',
    PGK: 'кины Папуа - Новой Гвинеи',
    PLN: 'польского злотого',
    RON: 'румынского лея',
    RUB: 'российского рубля',
    SAR: 'саудовского рияла',
    SEK: 'шведской кроны',
    SGD: 'сингапурского доллара',
    SZL: 'свазилендского лилангени',
    THB: 'тайского бата',
    TRY: 'турецкой лиры',
    USD: 'доллара США',
    UYU: 'уругвайского песо',
    WST: 'самоанской талы',
    ZAR: 'южноафриканского ранда',
  },
  chart: {
    time: 'Время',
    rate: 'Курс',
    opening: 'Открытие',
    highest: 'Максимальный',
    lowest: 'Минимальный',
    closing: 'Закрытие',
    monthNames: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
    dayNames: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
  },
  landingForm: {
    show: 'Показать',
    hide: 'Скрыть',
    requiredField: 'Необходимо отметить это поле',
    notEmptyField: 'Это поле не может быть пустым',
    incorrectEmail: 'Введи корректный адрес электронной почты',
    toShortPassword: 'Пароль слишком короткий',
    invalidPromocode: 'Акция на этой странице уже завершилась - зарегистрируйся через главную страницу',
    emailAlreadyExists: 'Этот e-mail нельзя использовать для регистрации',
    generalInvalid: 'Что-то пошло не так, попробуй позже',
    competitionFormThanks: 'Спасибо за участие в конкурсе!',
  },
  networkErrorStatus: {
    slow: 'Проблема с загрузкой курсов валют. Медленное интернет-соединение.',
    noNetwork: 'Проблема с загрузкой курсов валют. Проверь подключение к интернету.',
    default: 'Возникли технические проблемы. Обратись в Отдел Обслуживания Клиента.',
  },
  calculatorForegin: {
    continueButton: 'Продолжить обмен',
    exchangeRates: 'Курс обмена',
    details: 'Детали',
    amountYouSend: 'Сумма, которую вношу',
    countryYouSendMoney: 'Страна, в которую Ты отправляешь деньги',
    foreignTransferFee: 'Комиссия за международный перевод',
    foreignTransferType: 'Тип международного перевода',
    exchangeAmount: 'Сумма обмена',
    amountRecipientReceive: 'Сумма, которую получит получатель',
    minAmount: 'Сумма обмена слишком мала.',
    notSellCurrency: 'Продажа валюты недоступна.',
    transferTypes: {
      INTERNAL: {
        name: 'INTERNAL',
        desc: 'Деньги поступят примерно через 30 минут после получения Твоего перевода, не позднее следующего рабочего дня.',
      },
      TODAY: {
        name: 'TODAY',
        desc: 'Деньги поступят не позднее следующего рабочего дня.',
      },
      TODAY_OUR: {
        name: 'TODAY OUR',
        desc: 'Деньги поступят не позднее следующего рабочего дня.',
      },
      SEPA: {
        name: 'SEPA',
        desc: 'Деньги поступят в течении 1 - 2 рабочих дней.',
      },
      SEPA_INSTANT: {
        name: 'SEPA INSTANT',
        desc: 'Деньги поступят примерно за 1 минуту.',
      },
      SPOT: {
        name: 'SPOT',
        desc: 'Деньги поступят в течении 2 - 3 рабочих дней.',
      },
      ELIXIR: {
        name: 'ELIXIR',
        desc: 'Деньги поступят не позднее следующего рабочего дня.',
      },
      LOCAL: {
        name: 'LOCAL',
        desc: 'Деньги поступят не позднее следующего рабочего дня.',
      },
    },
  },
  timer: {
    update: 'Обновление через:',
    timeUnit: 'сек.',
  },
  countries: {
    AD: 'Андорра',
    AE: 'Объединённые Арабские Эмираты',
    AF: 'Афганистан',
    AG: 'Антигуа и Барбуда',
    AI: 'Ангилья',
    AL: 'Албания',
    AM: 'Армения',
    AN: 'Нидерландские Антильские острова',
    AO: 'Ангола',
    AQ: 'Антарктида',
    AR: 'Аргентина',
    AS: 'Американское Самоа',
    AT: 'Австрия',
    AU: 'Австралия',
    AW: 'Аруба',
    AX: 'Аландские острова',
    AZ: 'Азербайджан',
    BA: 'Босния и Герцеговина',
    BB: 'Барбадос',
    BD: 'Бангладеш',
    BE: 'Бельгия',
    BF: 'Буркина-Фасо',
    BG: 'Болгария',
    BH: 'Бахрейн',
    BI: 'Бурунди',
    BJ: 'Бенин',
    BL: 'Сен-Бартелеми',
    BM: 'Бермудские острова',
    BN: 'Бруней',
    BO: 'Боливия',
    BR: 'Бразилия',
    BS: 'Багамские острова',
    BT: 'Бутан',
    BV: 'Остров Буве',
    BW: 'Ботсвана',
    BY: 'Беларусь',
    BZ: 'Белиз',
    CA: 'Канада',
    CC: 'Кокосовые (Килинг) острова',
    CD: 'Демократическая Республика Конго',
    CF: 'Центральноафриканская Республика',
    CG: 'Республика Конго',
    CH: 'Швейцария',
    CI: "Кот-д'Ивуар",
    CK: 'Острова Кука',
    CL: 'Чили',
    CM: 'Камерун',
    CN: 'Китай',
    CO: 'Колумбия',
    CR: 'Коста-Рика',
    CU: 'Куба',
    CV: 'Кабо-Верде',
    CW: 'Кюрасао',
    CX: 'Остров Рождества',
    CY: 'Кипр',
    CZ: 'Чехия',
    DE: 'Германия',
    DJ: 'Джибути',
    DK: 'Дания',
    DM: 'Доминика',
    DO: 'Доминиканская Республика',
    DZ: 'Алжир',
    EC: 'Эквадор',
    EE: 'Эстония',
    EG: 'Египет',
    EH: 'Западная Сахара',
    ER: 'Эритрея',
    ES: 'Испания',
    ET: 'Эфиопия',
    FI: 'Финляндия',
    FJ: 'Фиджи',
    FK: 'Фолклендские острова',
    FM: 'Федеративные Штаты Микронезии',
    FO: 'Фарерские острова',
    FR: 'Франция',
    GA: 'Габон',
    GB: 'Великобритания',
    GD: 'Гренада',
    GE: 'Грузия',
    GF: 'Французская Гвиана',
    GG: 'Гернси',
    GH: 'Гана',
    GI: 'Гибралтар',
    GL: 'Гренландия',
    GM: 'Гамбия',
    GN: 'Гвинея',
    GP: 'Гваделупа',
    GQ: 'Экваториальная Гвинея',
    GR: 'Греция',
    GS: 'Южная Георгия и Южные Сандвичевы острова',
    GT: 'Гватемала',
    GU: 'Гуам',
    GW: 'Гвинея-Бисау',
    GY: 'Гайана',
    HK: 'Гонконг',
    HM: 'Острова Херд и Макдональд',
    HN: 'Гондурас',
    HR: 'Хорватия',
    HT: 'Гаити',
    HU: 'Венгрия',
    ID: 'Индонезия',
    IE: 'Ирландия',
    IL: 'Израиль',
    IM: 'Остров Мэн',
    IN: 'Индия',
    IO: 'Британская территория в Индийском океане',
    IQ: 'Ирак',
    IR: 'Иран',
    IS: 'Исландия',
    IT: 'Италия',
    JE: 'Джерси',
    JM: 'Ямайка',
    JO: 'Иордания',
    JP: 'Япония',
    KE: 'Кения',
    KG: 'Киргизия',
    KH: 'Камбоджа',
    KI: 'Кирибати',
    KM: 'Коморы',
    KN: 'Сент-Китс и Невис',
    KP: 'КНДР',
    KR: 'Республика Корея',
    KW: 'Кувейт',
    KY: 'Каймановы острова',
    KZ: 'Казахстан',
    LA: 'Лаос',
    LB: 'Ливан',
    LC: 'Сент-Люсия',
    LI: 'Лихтенштейн',
    LK: 'Шри-Ланка',
    LR: 'Либерия',
    LS: 'Лесото',
    LT: 'Литва',
    LU: 'Люксембург',
    LV: 'Латвия',
    LY: 'Ливия',
    MA: 'Марокко',
    MC: 'Монако',
    MD: 'Молдова',
    ME: 'Черногория',
    MF: 'Сен-Мартен',
    MG: 'Мадагаскар',
    MH: 'Маршалловы Острова',
    MK: 'Северная Македония',
    ML: 'Мали',
    MM: 'Мьянма',
    MN: 'Монголия',
    MO: 'Макао',
    MP: 'Северные Марианские острова',
    MQ: 'Мартиника',
    MR: 'Мавритания',
    MS: 'Монтсеррат',
    MT: 'Мальта',
    MU: 'Маврикий',
    MV: 'Мальдивы',
    MW: 'Малави',
    MX: 'Мексика',
    MY: 'Малайзия',
    MZ: 'Мозамбик',
    NA: 'Намибия',
    NC: 'Новая Каледония',
    NE: 'Нигер',
    NF: 'Остров Норфолк',
    NG: 'Нигерия',
    NI: 'Никарагуа',
    NL: 'Нидерланды',
    NO: 'Норвегия',
    NP: 'Непал',
    NR: 'Науру',
    NU: 'Ниуэ',
    NZ: 'Новая Зеландия',
    OM: 'Оман',
    PA: 'Панама',
    PE: 'Перу',
    PF: 'Французская Полинезия',
    PG: 'Папуа — Новая Гвинея',
    PH: 'Филиппины',
    PK: 'Пакистан',
    PL: 'Польша',
    PM: 'Сен-Пьер и Микелон',
    PN: 'Питкэрн',
    PR: 'Пуэрто-Рико',
    PS: 'Палестина',
    PT: 'Португалия',
    PW: 'Палау',
    PY: 'Парагвай',
    QA: 'Катар',
    RE: 'Реюньон',
    RO: 'Румыния',
    RS: 'Сербия',
    RU: 'Россия',
    RW: 'Руанда',
    SA: 'Саудовская Аравия',
    SB: 'Соломоновы Острова',
    SC: 'Сейшельские Острова',
    SD: 'Судан',
    SE: 'Швеция',
    SG: 'Сингапур',
    SH: 'Остров Святой Елены',
    SI: 'Словения',
    SJ: 'Шпицберген и Ян-Майен',
    SK: 'Словакия',
    SL: 'Сьерра-Леоне',
    SM: 'Сан-Марино',
    SN: 'Сенегал',
    SO: 'Сомали',
    SR: 'Суринам',
    ST: 'Сан-Томе и Принсипи',
    SV: 'Сальвадор',
    SY: 'Сирия',
    SZ: 'Эсватини',
    TC: 'Теркс и Кайкос',
    TD: 'Чад',
    TF: 'Французские Южные территории',
    TG: 'Того',
    TH: 'Таиланд',
    TJ: 'Таджикистан',
    TK: 'Токелау',
    TL: 'Восточный Тимор',
    TM: 'Туркменистан',
    TN: 'Тунис',
    TO: 'Тонга',
    TR: 'Турция',
    TT: 'Тринидад и Тобаго',
    TV: 'Тувалу',
    TW: 'Тайвань',
    TZ: 'Танзания',
    UA: 'Украина',
    UG: 'Уганда',
    UM: 'Малые отдалённые острова США',
    US: 'США',
    UY: 'Уругвай',
    UZ: 'Узбекистан',
    VA: 'Ватикан',
    VC: 'Сент-Винсент и Гренадины',
    VE: 'Венесуэла',
    VG: 'Британские Виргинские острова',
    VI: 'Американские Виргинские острова',
    VN: 'Вьетнам',
    VU: 'Вануату',
    WF: 'Уоллис и Футуна',
    WS: 'Самоа',
    XK: 'Косово',
    YE: 'Йемен',
    YT: 'Майотта',
    ZA: 'Южно-Африканская Республика',
    ZM: 'Замбия',
    ZW: 'Зимбабве',
  },
}
